<i18n src="@/i18n/components/SaveButton.json"></i18n>
<template>
    <button
        :disabled="disabled"
        class="inline-flex items-center py-2 pl-3 pr-4 border border-transparent text-sm font-medium rounded-md shadow-sm text-white
        bg-green-600 focus:outline-none transition-all duration-200"
        :class="disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-700 active:scale-95'"
        v-on="$listeners">
        <i class="fa fa-save text-xs"></i>
        <span class="ml-2.5 text-sm font-medium">
            <slot>{{ $t('save_button.label') }}</slot>
        </span>
    </button>
</template>

<script>
export default {
    name: "SaveButton",
    props: {
        disabled: Boolean
    }
}
</script>
